import * as React from 'react';
import {
  FormControlLabel as MuiFormControlLabel,
  FormHelperText as MuiFormHelperText,
} from '@material-ui/core';
import { Theme } from '@emotion/react';
import {
  formControlLabel,
  formControlLabelHelperText,
  formControlLabelPrimary,
  formControlWrapperContainer,
} from 'omakase/SelectionControls/selectionControlsCssDefs';
import SelectionControlsCore, {
  SelectionControlsCoreProps,
} from 'omakase/SelectionControls/SelectionControlsCore';

export type SelectionControlsCoreSize = 'small' | 'large';
export type SelectionControlsCoreWeight = 'book' | 'medium';

export interface SelectionControlsCoreLabelProps {
  /**
   * Size of the control's label
   */
  size?: SelectionControlsCoreSize;
  /**
   * Font weight for the control's label
   */
  weight?: SelectionControlsCoreWeight;
  /**
   * Label text for the control
   */
  label?: string | React.ReactNode;
  /**
   * Helper text for the control's label - rendered inside a <p>
   */
  helperText?: string | React.ReactNode;
  /**
   * Helper text for the control's label
   */
  endAuxiliaryContent?: React.ReactNode;
  'data-testid'?: string;
}

type RadioButtonProps = SelectionControlsCoreProps & SelectionControlsCoreLabelProps;

/**
 * Radio button with label.
 * Must be used within RadioButtonGroup (non-Formik) or FormRadioButtonGroup (Formik).
 */
const RadioButton: React.FunctionComponent<RadioButtonProps> = ({
  label,
  size = 'small',
  weight = 'medium',
  endAuxiliaryContent,
  helperText,
  value,
  ...rest
}) => {
  const mainControlContent = (
    <MuiFormControlLabel
      css={formControlLabel}
      control={<SelectionControlsCore {...rest} type="radio" value={value} />}
      value={value}
      label={
        <>
          <span css={(theme: Theme) => formControlLabelPrimary(theme, weight, size)}>{label}</span>
          {helperText && (
            <MuiFormHelperText
              css={(theme: Theme) => formControlLabelHelperText(theme, { error: false })}
            >
              {helperText}
            </MuiFormHelperText>
          )}
        </>
      }
    />
  );

  if (endAuxiliaryContent) {
    return (
      <div css={formControlWrapperContainer}>
        {mainControlContent}
        {endAuxiliaryContent}
      </div>
    );
  }

  return mainControlContent;
};

export default RadioButton;
